import { useEffect, useState } from 'react';
import api from '../api/axios';

// «Food delivery» ödəniş növü (PRO + superadmin tick + rol — backend utils/foodDelivery.js).
// /orders/pos-terminal cavabından:
//   enabled  — bu istifadəçi delivery düyməsini görür (rol tick-i)
//   tenant   — funksiya tenantda aktivdir
//   rooms    — admin otağı «Yalnız Food delivery» edə bilər
//   tableIds — «yalnız delivery» otaqlarındakı masalar (orada başqa ödəniş növü yoxdur)
// 60 san keşlənir (istifadəçi dəyişəndə köhnəlməsin). Offline → son bilinən dəyər (server sinxronda yoxlayır).
const LS_KEY = 'fp_food_delivery_info';
const EMPTY = { enabled: false, tenant: false, rooms: false, tableIds: [] };

let cached = null;
let cachedAt = 0;
let pending = null;

const readLs = () => {
    try { return { ...EMPTY, ...JSON.parse(localStorage.getItem(LS_KEY) || '{}') }; } catch { return EMPTY; }
};

export const fetchFoodDeliveryInfo = () => {
    if (cached && Date.now() - cachedAt < 60000) return Promise.resolve(cached);
    if (!pending) {
        pending = api.get('/orders/pos-terminal')
            .then((r) => {
                const d = r.data || {};
                cached = {
                    enabled: !!d.food_delivery,
                    tenant: !!d.food_delivery_tenant,
                    rooms: !!d.food_delivery_rooms,
                    tableIds: Array.isArray(d.delivery_table_ids) ? d.delivery_table_ids.map(Number) : [],
                };
                cachedAt = Date.now();
                try { localStorage.setItem(LS_KEY, JSON.stringify(cached)); } catch { /* ignore */ }
                return cached;
            })
            .catch(() => readLs())
            .finally(() => { pending = null; });
    }
    return pending;
};

export const useFoodDeliveryInfo = () => {
    const [info, setInfo] = useState(cached || EMPTY);
    useEffect(() => {
        let alive = true;
        fetchFoodDeliveryInfo().then((v) => { if (alive) setInfo(v); });
        return () => { alive = false; };
    }, []);
    return info;
};

// Bu istifadəçi delivery düyməsini görürmü (rol tick-i)
export const useFoodDelivery = () => useFoodDeliveryInfo().enabled;
